<template>
    <div class="content">
      <el-row class="bgW">
        <el-col :span="22">
          <!--检索条件-->
          <el-form :inline="true" size="mini" :model="search">
            <el-form-item label="开卡日期">
              <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="至"
                class="w300"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="searchTime"
              ></el-date-picker>
            </el-form-item>
  
            <el-form-item label="门店/门诊" v-if="!userInfo.shop_id">
              <el-select
                v-model="search.shop_id"
                clearable
                remote
                filterable
                :remote-method="remoteMethod"
                placeholder="请输入店铺名称"
                class="w120 mr20"
                @change="getStaff1"
              >
                <el-option
                  v-for="item in options.shop_id"
                  :key="item.shopId"
                  :label="item.shopName"
                  :value="item.shopId"
                />
              </el-select>
            </el-form-item>
             <el-form-item label="护理师">
            <el-select
              v-model="search.person_id"
              clearable
              remote
              filterable
              placeholder="请输入护理师名称"
              class="w120 mr20"
            >
              <el-option
                v-for="item in options.staff_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.shopName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
  
          <el-form-item label="开卡名称" v-if="!clienId">
                <el-input
                  v-model="search.name"
                  maxlength="30"
                  class="w120 mr20"
                  placeholder="请输入"
                  clearable
                />
          </el-form-item>
            <el-form-item label="姓名" v-if="!clienId">
              <el-input
                v-model="search.customer_name"
                maxlength="30"
                class="w84"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
            <el-form-item label="电话" v-if="!clienId">
              <el-input
                v-model="search.telephone"
                maxlength="30"
                class="w100"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
  
  
          </el-form>
        </el-col>
        <el-col :span="2" style="text-align: right;">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
          <!-- <el-button type="primary" icon="el-icon-search" size="mini" @click="exportData('export')">导出</el-button> -->
        </el-col>
      </el-row>
  
  
      <!--列表-->
      <el-row class="mt30">
        <!-- <div class="btnBox">
          <el-button
            type="primary"
            class="mb10"
            size="mini"
  
            @click="exportData('export')"
          >导出数据</el-button>
        </div> -->
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn label="开卡日期" prop="create_time" width="90" />

            <ElTableColumn label="顾客姓名" prop="customer_name" />

            <ElTableColumn label="客户手机号" prop="telephone" width="100"/>

            <ElTableColumn label="开卡人" prop="kk_user_name" />

            <ElTableColumn label="开卡部门" prop="shop_name" />

            <ElTableColumn label="开卡名称" width="150">
              <template slot-scope="{ row }">
                <span
                  @click="applyExpend(row.id,row.customer_id)"
                >
                {{ row.name }}
                </span>
                
              </template>
            </ElTableColumn>

            <ElTableColumn label="卡项别名" prop="goods_alias_name" width="140" />
  
            <ElTableColumn label="开卡金额">
              <template slot-scope="{ row }">
                <span
                  @click="kkDetail(row)"
                >
                {{ row.kk_money }}
                </span>
                
              </template>
            </ElTableColumn>

            <ElTableColumn label="实付金额" prop="pay_amount" />
            <ElTableColumn label="实付本金" prop="pay_balance" />
            <ElTableColumn label="实付赠金" prop="pay_gift" />
            <ElTableColumn label="实付店转" prop="pay_store" />

            <ElTableColumn label="开卡次数">
              <template slot-scope="{ row }">
                <span
                v-if="row.service_type == 2"
                @click="changeNum(row)"
                >
                {{ row.num }}
                </span>
                <span v-else>{{ row.num }}</span>
              </template>
            </ElTableColumn>
           
            <ElTableColumn label="有效期" width="260">
              <template slot-scope="{ row }">
                <span
                v-if="row.service_type == 1"
                @click="changeDate(row)"
                >
                {{ row.start_time }}-{{row.end_time}}
                </span>
                <span v-else>无限制</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="消耗次数" prop="sy_num" />
            <ElTableColumn label="剩余次数" prop="yy_num" />

            <ElTableColumn label="剩余本金" prop="surplus_balance" />
            <ElTableColumn label="剩余赠金" prop="surplus_gift" />
            <ElTableColumn label="剩余店转" prop="surplus_store" />

            <ElTableColumn label="申请状态" width="260">
              <template slot-scope="{ row }">
                <span @click="applyDetails(row)" >
                  {{row.apply_status_text }}
                </span>
              </template>
            </ElTableColumn>
            <!-- <ElTableColumn label="卡项状态" width="260">
              <template slot-scope="{ row }">
                <span >
                  {{row.status_text }}
                </span>
              </template>
            </ElTableColumn> -->
            <ElTableColumn label="状态" width="260">
              <template slot-scope="{ row }">
                <span >
                  {{row.finish_status }}
                </span>
              </template>
            </ElTableColumn>

            <ElTableColumn label="开卡备注" prop="description" />

            <ElTableColumn label="操 作" fixed="right" width="160">
              <template slot-scope="{ row }">
                <span class="theme ml20" @click="tapDetail(row.id)">查 看</span>
                
              </template>
            </ElTableColumn>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
  
      <!-- 调整弹出 -->
      <el-dialog title="次卡调整" :visible.sync="changeNumPop" width="40%">
        <el-form
          :inline="true"
          ref="changeData"
          size="mini"
          :model="changeData"
          label-width="150px"
        >
          <el-form-item label="调整开卡次数" prop="num">
            <el-input-number class="w300" v-model="changeData.num" :min="-10000" :precision="0" ></el-input-number>
          </el-form-item>
        </el-form>
  
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="changeNumPop = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="submitFormC('changeData')">确 定</el-button>
        </span>
  
      </el-dialog>
  
  
      <el-dialog title="月卡调整" :visible.sync="changeDatePop" width="40%">
        <el-form
          :inline="true"
          ref="changeData"
          size="mini"
          :rules="rules"
          :model="changeData"
          label-width="150px"
        >
          <el-form-item label="调整卡项到期时间" prop="end_time">
  
            <el-date-picker
                v-model="changeData.end_time"
                type="date"
                class="w300"
                placeholder="请选择调整卡项到期时间"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
          </el-form-item>
        </el-form>
  
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="changeDatePop = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="submitFormC('changeData')">确 定</el-button>
        </span>
  
      </el-dialog>
  
      <!-- 核销弹出 -->
      <el-dialog title="核销处理" :visible.sync="verificationPop" width="40%">
        <el-form
          :inline="true"
          ref="verifyDetail"
          size="mini"
          :rules="rules"
          :model="verifyDetail"
          label-width="90px"
        >
          <el-form-item label="服务次数" prop="num">
            <el-input
              v-model="verifyDetail.num"
              maxlength="30"
              class="w200"
              placeholder="请输入服务次数"
              clearable
            />
          </el-form-item>
          <el-form-item label="护理师1" prop="nurse_id_one">
            <el-select
              v-model="verifyDetail.nurse_id_one"
              placeholder="请选择"
              class="w200"
              @change="changeStaff"
            >
              <el-option
                v-for="item in options.sale_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label=" 护理师2">
            <el-select
              v-model="verifyDetail.nurse_id_two"
              placeholder="请选择"
              class="w200"
              @change="changeStaff"
            >
              <el-option
                v-for="item in options.sale_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="verificationPop = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="submitForm('verifyDetail')">确 定</el-button>
        </span>
      </el-dialog>
  
      <!-- 卡项消耗审核流程弹窗 --> 
      <el-dialog
        title="卡项消耗审核流程"
        :visible.sync="applyPop"
        width="40%"
        >
        <div class="block">
          <el-timeline>
            <el-timeline-item timestamp="" placement="top"  >
                <el-card>
                  <h4>申请时间:{{ auditDetails.create_time }}</h4>
                  <p>申请人：{{ auditDetails.apply_audit_name }}</p>
                  <p>申请原因：{{auditDetails.apply_reason}}</p>
                  <p >审核状态：<span style="color:red">审核中</span></p>
                  <p >卡项信息如下：</p>
                  <p >
                    卡项名称：{{auditDetails.service.service_name}}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    卡项类型：{{auditDetails.service.service_type}}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    开卡金额：{{auditDetails.service.kk_money}}
                  </p>
                  <p >
                    已消耗本金：{{auditDetails.service.already_consume_bj}}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    已消耗赠金：{{auditDetails.service.already_consume_zj}}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    已消耗店转：{{auditDetails.service.already_consume_dz}}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    已核销次数：{{auditDetails.service.already_cancel_num}}
                  </p>
  
                  <p v-if=" auditDetails.service.service_type == '次卡'">
                  卡项次数：{{auditDetails.service.num}}
                  </p>
                  <p v-if=" auditDetails.service.service_type == '疗程卡'">
                    卡项有效期：{{auditDetails.service.start_time}}至{{auditDetails.service.end_time}}
                  </p>
  
                </el-card>
              </el-timeline-item>
            <el-timeline-item timestamp="" placement="top"  v-for="(item) in auditDetailList ">
                <el-card>
                  <h4>审核时间:{{ item.apply_audit_time }}</h4>
                  <p>审核人：{{ item.apply_audit_name }}</p>
                  <p>审核备注：{{item.apply_audit_reason}}</p>
                  <p style="color:red">审核状态：{{item.is_pass_test }}</p>
                </el-card>
              </el-timeline-item>
  
          </el-timeline>
        </div>
      </el-dialog>
  
      <!-- 卡项消耗申请弹窗 -->
      <el-dialog title="核销处理" :visible.sync="applyConsumePop" width="40%">
        <el-form
          :inline="true"
          ref="applyDetail"
          size="mini"
          :rules="rules"
          :model="applyDetail"
          label-width="90px"
        >
  
          <el-form-item label="申请原因:" prop="reason">
            <el-input v-model="applyDetail.reason" class="w300" placeholder="请填写申请备注" type="textarea" />
          </el-form-item>
        
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="applyConsumePop = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="apply()">确 定</el-button>
        </span>
      </el-dialog>
  
      <!-- 卡项恢复申请弹窗 -->
      <el-dialog title="卡项恢复申请处理" :visible.sync="applyRegainPop" width="40%">
        <el-form
          :inline="true"
          ref="applyRegainDetail"
          size="mini"
          :rules="rules"
          :model="applyRegainDetail"
          label-width="90px"
        >
          <el-form-item label="申请原因:" prop="reason">
            <el-input v-model="applyRegainDetail.reason" class="w300" placeholder="请填写申请备注" type="textarea" />
          </el-form-item>
        
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="applyRegainPop = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="applyRegain()">确 定</el-button>
        </span>
      </el-dialog>
  
      <!-- 卡项信息详情 --> 
      <el-dialog
        title="卡项信息"
        :visible.sync="serviceDetailPop"
        width="75%"
       >
       <p>
        <span style="padding-left: 10px;">开卡金额：{{ serviceDetail.kk_money }}</span>
        <span style="padding-left: 20px;">消耗本金：{{ serviceDetail.consume_money }}</span>
        <span style="padding-left: 20px;">消耗赠金：{{ serviceDetail.consume_gratuity }}</span>
        <span style="padding-left: 20px;">消耗店转：{{ serviceDetail.consume_store_transfer }} </span>
      </p>
  
      <p>
        <span style="padding-left: 10px;">卡项已消耗本金：{{ serviceDetail.consume_bj }}</span>
        <span style="padding-left: 20px;">卡项已消耗赠金：{{ serviceDetail.consume_zj }}</span>
        <span style="padding-left: 20px;">卡项已消耗店转：{{ serviceDetail.consume_dz }} </span>
        <span style="padding-left: 20px;">卡项已消耗次数：{{ serviceDetail.consume_num }} </span>
      </p>
        <el-table
          :data="tableData"
            border
            style="width: 100%">
            <el-table-column
              prop="create_time"
              label="退货日期"
              width="180">
            </el-table-column>
            <el-table-column
              prop="refund_bj"
              label="退货本金"
              width="180">
            </el-table-column>
            <el-table-column
              prop="refund_zj"
              label="退货赠金">
            </el-table-column>
            <el-table-column
              prop="refund_dz"
              label="退货店转">
            </el-table-column>
            <el-table-column
              prop="refund_num"
              label="退货次数">
            </el-table-column>
            <el-table-column
              prop="type_text"
              label="卡类型">
            </el-table-column>
        </el-table>
    
      </el-dialog>
  
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import pagination from "@/components/Pagination";
  import { serviceList, addServiceLog, gbservice,changeService,serviceInfo,pastServiceList } from "@/api/client";
  import { staffList } from "@/api/staff";
  import { getShopList } from "@/api/shop";
  import { apply, auditDetail,serviceRegainApply,expiredServiceApply } from "@/api/serviceConsume";
  
  class Search {
    person_id = ""; // 护理师
    start_time = ""; // 开始日期
    endTime = ""; // 结束日期
    customer_name = ""; // 客户名称
    telephone = ""; // 客户电话
    effective = "";
    shop_id = "";
    name = ""; //开卡名称
  }
  class Page {
    total = 0;
    page = 1;
    limit = 10;
  }
  class VerifyDetail {
    service_id = "";
    nurse_id_one = "";
    nurse_id_two = "";
    num = "";
    start_time = "";
    end_time = "";
  }
  
  class changeData {
    service_id = "";
    num = "";
    end_time = "";
  }
  
  class Rules {
    nurse_id_one = [
      { required: true, message: "请选择护理师", trigger: "change" }
    ];
    num = [{ required: true, message: "请输入服务次数", trigger: "blur" }];
  }
  
  class Options {
    staff_id = []; // 护理师
    constructor() {
      this.shop_id = []; // 店铺
    }
    sale_id = [];
    effective = [
      { id: 15, name: "15天" },
      { id: 30, name: "30天" },
      { id: 45, name: "45天" },
      { id: 60, name: "60天" }
    ];
  }
  
  //卡项消耗申请
  class ApplyDetail {
    reason = "";
  
  }
  
  //卡项消耗恢复申请
  class ApplyRegainDetail {
    reason = "";
  
  }
  
  class auditDetails {
    service={};
  }
  
  class serviceDetail {
    kk_money = '0.00';
    consume_money = '0.00';
    consume_gratuity = '0.00';
    consume_store_transfer = '0.00';
    consume_bj = '0.00';
    consume_zj = '0.00';
    consume_dz = '0.00';
    consume_num = 0
    
  }
  
  export default {
    name: "ServeRecord",
    components: {
      pagination
    },
    props: {
      clienId: {
        type: String,
        default: ""
      },
      detail: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        search: new Search(),
        verifyDetail: new VerifyDetail(),
        applyDetail: new ApplyDetail(), //卡项消耗申请表单
        applyRegainDetail:new ApplyRegainDetail(),
        changeData: new changeData(),
        serviceDetail : new serviceDetail(),//卡项信息
        options: new Options(),
        rules: new Rules(),
        page: new Page(), // 分页
        list: [], // 数据展示
        auditDetails:new auditDetails(),
        auditDetailList :[],
        verificationPop: false, //核销弹出
        changeNumPop: false, //调整弹出_次卡
        changeDatePop: false, //调整弹出_月卡
        applyPop:false,
        applyConsumePop:false,
        applyRegainPop:false,
        serviceDetailPop:false,
        tableData:[],
        timeValue: [],
        value1: [],
        pickerBeginDateBefore: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        }
       
      };
    },
  
    mounted() {
      this.getList();
      this.getStaff1();
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    methods: {
  
      kkDetail(row){
        this.serviceDetailPop=true;
        serviceInfo({ service_id:row.id }).then(
          res => {
            this.tableData = res.data.refund_goods_log
            this.serviceDetail = res.data
          }
        );
      },
    getStaff1() {
      staffList({ page: 1, limit: 1000000, shopId: this.search.shop_id }).then(
        res => {
          this.options.staff_id = res.list;
        }
      );
    },
      // 获取列表
      getList(option) {
        if (option === "search") this.page = new Page();
        pastServiceList({
          ...this.search,
          customer_id: this.clienId,
          ...this.page
        }).then(res => {
          this.list = res.list;
          this.page.total = res.dataCount;
        });
        this.getStaff();
      },
  
      // 导出
      exportData(option){
        serviceList({
          ...this.search,
          export : 1
        }).then(res => {
          window.open(res.url);
        });
        this.getStaff();
      },
  
      // 客户所在店铺员工列表
      getStaff() {
        staffList({ page: 1, limit: 1000000, shopId: this.detail.shopid_U }).then(
          res => {
            this.options.sale_id = res.list;
          }
        );
      },
      // 重复护理师提示
      changeStaff() {
        if (this.verifyDetail.nurse_id_one == this.verifyDetail.nurse_id_two) {
          this.$message({
            type: "warning",
            message: "请选择不同护理师"
          });
          this.verifyDetail.nurse_id_two = "";
        }
      },
      // 开卡日期搜索
      searchTime(val) {
        if (val) {
          this.search.start_time = val[0];
          this.search.endTime = val[1];
        } else {
          this.search.start_time = "";
          this.search.endTime = "";
          this.getList("search");
        }
      },
      // 点击详情
      tapDetail(id) {
        const query = {
          id: id,
          activeName: "second",
          clienId: this.clienId,
          detail: this.detail
        };
        // this.$router.push({ name: "客户服务详情", query });
        let route = this.$router.resolve({ name: "客户服务详情", query });
        window.open(route.href, '_blank');
      },
  
      // 点击调整次数
      changeNum(date){
  
        this.$message.error('次卡无法调整');
        return false;
  
  
        this.changeNumPop = true;
        this.changeData = new changeData();
  
        this.changeData.service_id = date.id;
        this.changeData.shop_id = date.id;
        this.changeData.old_num = date.num;
        this.changeData.service_type =  date.service_type;
      },
      // 点击调整日期
      changeDate(date){
        this.changeDatePop = true;
        this.changeData = new changeData();
  
        this.changeData.service_id = date.id;
        this.changeData.shop_id = date.id;
        this.changeData.old_time = date.end_time;
        this.changeData.service_type =  date.service_type;
        this.changeData.customer_id =  date.customer_id;
        this.changeData.shop_id =  date.shop_id;
      },
      // 点击核销
      verification(id) {
        this.verificationPop = true;
        this.verifyDetail = new VerifyDetail();
        this.verifyDetail.service_id = id;
      },
      //卡项消耗申请
      applyExpend(id,customer_id){
          this.applyConsumePop =true;
          this.applyDetail.service_id = id;
          this.applyDetail.customer_id = customer_id;
        },
            //卡项消耗申请
      apply(){
        expiredServiceApply({
            ...this.applyDetail,
          }).then(res => {
            this.$message({
              type: "success",
              message: "提交成功"
            });
            this.applyConsumePop = false;
            this.applyDetail.reason = '';
          });
      },
      //查看卡项消耗申请详情
      applyDetails(row){
        
          auditDetail({
              id : row.apply_id,
            }).then(res => {
              this.applyPop = true;
              console.log(res,'日志');
              this.auditDetails = res.data.apply;
              this.auditDetailList = res.data.audit;
            
              console.log(res);
            });
      },
      //卡项消耗恢复申请弹窗
      applyRegainExpend(id){
        this.applyRegainPop =true;
        this.applyRegainDetail.service_id = id;
       
      },
      //卡项消耗恢复申请
      applyRegain(){
       
        serviceRegainApply({
            ...this.applyRegainDetail,
            customer_id : this.clienId
          }).then(res => {
            this.$message({
              type: "success",
              message: "提交成功"
            });
            this.applyRegainPop = false;
            this.applyRegainDetail.reason = '';
          });
      },
  
  
  
      // 选择时间
      changeTime(e) {
        this.verifyDetail.start_time = e[0];
        this.verifyDetail.end_time = e[1];
      },
      // 提交核销
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.hint("use", "核销此客户服务");
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      // 调整提交
      submitFormC(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.hint("change", "调整此客户服务");
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      // 提示
      hint(type, text) {
        this.$confirm(`${text}，是否确定？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (type == "use") {
              this.confirm();
            } else if(type == "change"){
              this.changeServeFunction();
            } else {
              this.nullify(type);
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      // 点击失效
      nullify(id) {
        gbservice({ service_id: id }).then(res => {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getList();
        });
      },
      // 确定核销
      confirm() {
        addServiceLog({
          ...this.verifyDetail,
          shop_id: this.detail.shop_id,
          customer_id: this.clienId
        }).then(res => {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.verificationPop = false;
          this.getList();
        });
      },
      // 确定调整
      changeServeFunction() {
        // console.log(changeData);
        changeService({
          ...this.changeData,
  
        //   shop_id: this.detail.shop_id,
        
        }).then(res => {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.changeDatePop = false;
          // this.getList();
        });
      },
  
      // 搜索门店
      remoteMethod(e) {
        getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
          this.options.shop_id = res.list;
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  </style>
  